import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { ChangeRequestStore } from 'stores/requests/requests-store';
import TailwindRejectionReasonEditor from 'widgets/bussiness/rejection-reason-editor-tw';
import TailwindRejectedByEditor from 'widgets/bussiness/rejected-by-editor-tw';
import { RejectProperties } from 'site/pages/shared/events-and-requests/reject-modal';
import TailwindMessage from 'site/pages/landing-pages/mobile/alerts/message-tw';
import { ItemReference } from 'stores/dataStore';

export interface RequestCancelPopupTailwindProps extends WithTranslation {
  requestId: string;
  open: boolean;
  changeRequestStore?: ChangeRequestStore;
  onCancel?: () => void;
  onSuccess?: () => void;
  onError?: () => void;
}

interface CancelRequestState extends RejectProperties {
  loading: boolean;
  errMsgs: string[];
}

const title = 'Are you sure you want to CANCEL the request?';
const subtitle = 'This action cannot be undone, and the request will be completely deleted.';

@connect(['changeRequestStore', ChangeRequestStore])
class RequestCancelPopupTailwind extends React.Component<RequestCancelPopupTailwindProps, CancelRequestState> {
  static defaultProps = { onCancel: () => {}, onSuccess: () => {}, onError: () => {} };
  state: CancelRequestState = { rejectReason: '', rejectedById: '', rejectionReasonId: '', loading: false, errMsgs: [] };

  private onSubmit = async () => {
    const { rejectReason, rejectedById, rejectionReasonId } = this.state;
    const errMsgs = [];
    const { onSuccess, onError, changeRequestStore, requestId } = this.props;

    if (!rejectReason) errMsgs.push(this.props.t('Invalid Reject reason text'));
    if (!rejectionReasonId) errMsgs.push(this.props.t('Is required to select Reject Reason'));
    if (!rejectedById) errMsgs.push(this.props.t('Is required to select Rejected By'));

    if (errMsgs.length) {
      this.setState({ errMsgs });
      return;
    }

    this.setState({ loading: true });
    try {
      const response = await changeRequestStore.deleteById(requestId, rejectReason, rejectionReasonId, rejectedById);
      if (response?.isSuccess) {
        onSuccess();
        changeRequestStore.clear();
      }
    } catch (error) {
      onError();
    }
    this.setState({ loading: false });
  };
  private onRejectRequest = () => this.onSubmit();

  private onRejectReasonChange = (rejectionReason: ItemReference) => {
    this.setState({ rejectionReasonId: rejectionReason.id });
  };

  private onRejectedByChange = (rejectedBy: ItemReference) => {
    this.setState({ rejectedById: rejectedBy.id });
  };

  private onRejectReasonTextChange = (val: string) => {
    this.setState({ rejectReason: val });
  };

  private onCancel = () => this.props.onCancel();
  private onDismiss = () => this.setState({ errMsgs: [] });

  public render() {
    const { t, open } = this.props;
    const { rejectionReasonId, rejectedById, rejectReason, errMsgs, loading } = this.state;
    const rejectBtn = 'Reject Request';

    if (!open) return null;

    const errors = errMsgs.length ? (
      <TailwindMessage
        error
        icon="exclamation-circle"
        header={t('An error ocurred')}
        list={errMsgs}
        onDismiss={this.onDismiss}
        className="mb-4"
      />
    ) : null;

    return (
      <>
        {/* Fondo semitransparente con desenfoque y espacio para la toolbar */}
        <div
          className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm"
          style={{
            paddingLeft: '56px', // espacio para la toolbar izquierda
            paddingRight: '16px' // espacio para scrollbar derecha
          }}
        >
          {/* Contenedor del modal con borde y sombreado */}
          <div className="bg-white rounded-lg border border-gray-300 shadow-2xl w-full max-w-sm p-4 relative">
            {/* Botón Back */}
            <button onClick={this.onCancel} className="flex items-center gap-1 text-sm text-black-600 mb-2">
              ← {t('Back')}
            </button>

            {/* Errores */}
            {errors}

            <h3 className="text-lg font-semibold mb-4">{t(title)}</h3>

            {/* Selectores */}
            <div className="mb-3">
              <label className="block text-sm text-gray-700 mb-1">{t('Select Reject Reason')}</label>
              <TailwindRejectionReasonEditor value={rejectionReasonId} onChange={this.onRejectReasonChange} />
            </div>

            <div className="mb-3">
              <label className="block text-sm text-gray-700 mb-1">{t('Select Rejected By')}</label>
              <TailwindRejectedByEditor value={rejectedById} onChange={this.onRejectedByChange} />
            </div>

            <div className="mb-3">
              <label className="block text-sm text-gray-700 mb-1">{t('Reason')}</label>
              <textarea
                className="w-full p-2 border border-gray-300 rounded"
                onChange={e => this.onRejectReasonTextChange(e.target.value)}
                value={rejectReason}
                placeholder={t('Reason')}
                rows={4}
              />
            </div>

            <p className="block text-sm text-gray-700 mb-1">{t(subtitle)}</p>

            <button className="w-full bg-gray-200 text-black py-2 rounded mt-2" onClick={this.onCancel} disabled={loading}>
              {t('Back')}
            </button>

            <button className="w-full bg-primary-600 text-white py-2 rounded mt-2" onClick={this.onRejectRequest} disabled={loading}>
              {loading ? t('Cancelling...') : t(rejectBtn)}
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(RequestCancelPopupTailwind);
